import Axios from 'axios';

Axios.defaults.baseURL = 'http://3.109.56.190/api';

export const axiosInstance = Axios.create({});
